module.exports = __webpack_public_path__ + "img/occupation_promote_upperlayer.c8ce16d3.svg";